export default __webpack_public_path__ + "static/media/gloves_of_vicious_frenzy.a01725a9.jpg";